import React, { memo, useRef, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import VIDEO_EVENTS from 'constants/video-events';
import { StyledVideoPlayer } from './StyledComponents';

const VideoComponent = ({ width, height, onEvent, forwardedRef, children }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const videoRef = forwardedRef || useRef();

  useEffect(() => {
    const video = videoRef.current;

    const events = {
      timeupdate: () => onEvent(VIDEO_EVENTS.TIME_UPDATE),
      loadedmetadata: () => onEvent(VIDEO_EVENTS.LOADED_METADATA),
      play: () => onEvent(VIDEO_EVENTS.PLAY),
      pause: () => onEvent(VIDEO_EVENTS.PAUSE),
      waiting: () => onEvent(VIDEO_EVENTS.WAITING),
      seeking: () => onEvent(VIDEO_EVENTS.SEEKING),
      seeked: () => onEvent(VIDEO_EVENTS.SEEKED),
      loadstart: () => onEvent(VIDEO_EVENTS.LOAD_START),
      canplay: () => onEvent(VIDEO_EVENTS.CAN_PLAY),
      playing: () => onEvent(VIDEO_EVENTS.PLAYING),
      ended: () => onEvent(VIDEO_EVENTS.ENDED),
    };

    Object.entries(events).forEach(([key, value]) => video.addEventListener(key, value));

    return () => {
      Object.entries(events).forEach(([key, value]) => video.removeEventListener(key, value));
    };
  }, [onEvent, videoRef]);

  // it's willUnmount.
  // For track cases when player has stopped without "stop" button press. E.g. with back button
  useEffect(() => () => onEvent(VIDEO_EVENTS.PAUSE), [onEvent]);

  return (
    <StyledVideoPlayer width={width} height={height} ref={videoRef}>
      {children}
    </StyledVideoPlayer>
  );
};

VideoComponent.propTypes = {
  onEvent: PropTypes.func.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};

export default memo(forwardRef((props, ref) => <VideoComponent forwardedRef={ref} {...props} />));
